import React from 'react';

export default function Card({ title, actions, children, style, interactive }) {
  return (
    <section
      className={`card${interactive ? ' card-interactive' : ''}`}
      style={style}
    >
      {(title || actions) && (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            marginBottom: 'var(--space-4)',
          }}
        >
          {title && (
            <h2 style={{ fontSize: 'var(--font-size-lg)', margin: 0, display: 'flex', alignItems: 'center' }}>
              <span className="tile-mark" aria-hidden="true" />
              {title}
            </h2>
          )}
          {actions}
        </div>
      )}
      {children}
    </section>
  );
}
